var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{staticClass:"ddi favorite-button",class:[ {'active': _vm.internalIsFavorite}, _vm.iconClass ],on:{"click":function($event){_vm.internalIsFavorite = !_vm.internalIsFavorite}}})}
var staticRenderFns = []

export { render, staticRenderFns }